module.exports = __webpack_public_path__ + "static/img/4.8f16096.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/aleksis/4.jpg
// module id = pwGc
// module chunks = 0